export default __webpack_public_path__ + "static/Group-1240-fb543df103325ac0276b700535179d70.png";